import {useState, useEffect} from "react";
import Container from "./Container";
import UserInfo from "components/UserInfo";
import UnityRenderer from "../UnityRenderer/UnityRenderer";
import {getWorld} from "api-v3";
import {URL} from "utils";
import ProgressBox from "components/Canvas/ProgressBox";

function Index({...props}) {
  const [isUnityGame, setIsUnityGame] = useState(null);
  const [unityData, setUnityData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchWorldData = async () => {
      try {
        const queryParams = new URLSearchParams(window.location.search);
        const pId = queryParams.get("pid");

        const world = await getWorld({id: pId});
        const isUnity = world?.data?.language === "UNITY";

        setIsUnityGame(isUnity);

        if (isUnity) {
          const response = await fetch(`${URL.S3_WORLD_STORAGE}/${pId}.json`);
          const data = await response.json();
          setUnityData(data);
        }
      } catch (error) {
        console.error("Failed to fetch world data:", error);
        setIsUnityGame(false);
        setUnityData(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWorldData();
  }, []);

  if (isLoading) {
    return (
      <div
        style={{
          backgroundColor: "black",
          color: "white",
          fontSize: "20px",
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ProgressBox />
      </div>
    );
  }

  return <UserInfo>{isUnityGame ? <UnityRenderer unityData={unityData} /> : <Container {...props} />}</UserInfo>;
}

export default Index;
